import ImgIclima from "../../assets/images/clients/iclima.png";
import ImgImpak from "../../assets/images/clients/impak.png";
import ImgSix from "../../assets/images/clients/six.png";

const CLIENTS_LIST = [
  {
    id: 0,
    img: ImgImpak,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud ",
  },
  {
    id: 1,
    img: ImgIclima,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud ",
  },
  {
    id: 2,
    img: ImgSix,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud ",
  },
];

for (let i = 3; i < 45; i++) {
  CLIENTS_LIST.push({
    id: i,
    img: ImgImpak,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud ",
  });
}

export { CLIENTS_LIST };
